import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    let title = "Default Title"; // Default title
    const titles = {
      "/": "Login",
      "/login": "Login",
      "/signup": "Signup",
      "/pre-admission": "Application Form",
      "/admin/dashboard": "Dashboard",
      "/admin/add-student": "Add Student",
      "/admin/view-student": "View Student",
      "/admin/student-billing": "Student Billing",
      "/admin/all-billing": "Student Billing",
      "/admin/staff/wallet": "Transfer Wallet",
      "/admin/wallet": "Transfer Wallet",
      "/admin/wallet-history": "Wallet History",
      "/admin/notice": "Notice",
      "/admin/product-category": "Add Category",
      "/admin/product-sub-category": "Add Sub Category",
      "/admin/product-bundle/create": "Add Stock",
      "/admin/product-bundle/list": "List Stock",
      "/admin/product-vendor/list": "Vendor List Stock",
      "/admin/subject-add": "Add Subject",
      "/admin/subject-class/assign": "Assign Subject",
      "/admin/teacher-add": "Add Teacher",
      "/admin/teacher-subject/assign": "Assign Subject to Teacher",
      "/admin/department-add": "Add Department",
      "/admin/applicant/view": "View Application",
      "/admin/application/exam": "List Exam & Create Exam for Pre Admission",
      "/admin/application/exam/publish_result": "Publish Result Pre Admission",
      "/admin/application/parent/interview": "Parent Interview",
      "/pre-admission/student_login": "Pre-admission Student Login",
      "/admin/fees_structure/list": "Fees Structure",
      "/admin/fees_structure/others": "Others Fees Structure",
      "/admin/expense/add": "Add Expense",
      "/admin/expense/category": "Expense Category",
      "/admin/expense/sub-category": "Expense Sub Category",
      "/admin/vendor/list": "Vendor List",
      "/admin/class-section/manage": "Class Section Management",
      "/admin/student/product-billing": "Student Product Billing",
      "/admin/student/product-billing/history": "Student Product Billing History",
      "/admin/school/academic-years": "School Academic Management",
      "/admin/exam-management/add": "Exam Management",
      "/admin/exam-subject-management/add": "Exam Subject Management",
      "/admin/mark-roll/entry": "Mark Roll Entry",
      "/admin/mark-sheet/list": "List All Mark Sheet",
      "/admin/grade-rules/list": "List Grade Rules",
      "/admin/permission-master/list": "List Permission Master",
      "/admin/teacher-permission/list": "List Teacher Permission",
      "/admin/mark-types/list": "List Mark Types",
      "/admin/exam/templates/builder": "Template Builder",
      "/admin/student/id-card": "Student ID Card",
      "/admin/teacher/id-card": "Teacher ID Card",
      "/admin/class-section/working-days": "Class Section Working Days",
      "/admin/salary-structure": "Salary Structure",
      "/admin/salary-payroll": "Salary Payroll",
      "/admin/unpaid-students": "Unpaid Students",
    };

    // Check for exact match
    if (titles[location.pathname]) {
      title = titles[location.pathname];
    } 
    // Handle dynamic route
    else if (location.pathname.startsWith("/admin/view-student-details/")) {
      title = "View Student Details";
    } else if (location.pathname.startsWith("/admin/product-bundle/view/")) {
      title = "View Product Variant";
    } else if (location.pathname.startsWith("/valid_student/")) {
      title = "Valid Student";
    } else if (location.pathname.startsWith("/valid_teacher/")) {
      title = "Valid Teacher";
    } else if (location.pathname.startsWith("/admin/edit-student/")) {
      title = "Edit Student";
    }

    document.title = title;
  }, [location]);

  return null; // No UI needed
};

export default PageTitle;
